//PACKAGES
import React from "react";
import { cloneDeep, isEqual } from "lodash";

//OPEN LAYERS
import Layer from "ol/layer/Layer";
import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Map from "ol/Map";
import View from "ol/View";
import Select from "ol/interaction/Select";
import Feature from "ol/Feature";
import { LineString, Point, Polygon } from "ol/geom";
import * as olProj from "ol/proj";
import { defaults as defaultInteractions } from "ol/interaction";

import * as olExtent from "ol/extent";
import { pointerMove } from "ol/events/condition";
import "../../styles/openLayers.scss";
import "ol/ol.css";

//LOCAL
import settings from "../../../src/settings";
import { defaultLineStringStyle, defaultStyle } from "./olStyles.js";
import { convexHull } from "../../utils/geom";

// const mapboxgl = require('old-mapbox');
import mapboxgl from "!mapbox-gl";

// A FULL LIST OF NEEDED ITEMS IN THE OL LAYER MAP API:

// add, remove, layer
// update layer -- loop through features to add
// add feature --- must be conditional on which feature it is
// remove feature
// pop up feature so we can add this right

//Key point -- NEED A STYLE API. This is the next point that we need to work on -- how do we set styles one way or another?

/*
 *  They key thing here is that we need two real style apis -- do we have color? Do we have a config? Poepal need to pass in the style functions from the created svg markers.
 *  You also need to be able to pass a pure OL feature object if necessary.
 *
 * So, on each side, we have a get style function on the map layers attached to the config function for each layer type
 * . This passes in a complete ol style object, as configure in the olStyles sheet, that this component expects and displays.
 * */

/*
 *
 * api needs to be able to create three different kinds of map features:
 * a line, connecting in order and based on lat lon
 *
 *
 * a polygon -- how do we pass this?
 *
 * a point, the easiest of them all!
 *
 * */

const FIT_PADDING = [20, 20, 20, 20];

class OLLayerMap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      drawPoly: null,
      freeDrawToggle: false,
      isDrawingPoly: false,
      popup: {
        contents: "",
        coord: null,
      },
      lassoPolys: [],
      lassoPointIds: [],
      focusedPoints: [], // used to set the bounds on the map w/o rerendering
      showPointLabels: false,
      infoOverlayText: {},
    };

    this.STREET_TILES = "mapbox/light-v10"; //
    this.SAT_TILES = "alexgilson/clnbv532d07jl01p75xj9hjhs";
    this.tileType = this.STREET_TILES;
    this.map_access_token = settings.mapboxApiKey;
    this.map = null;
    this.featuresLayer = null;

    this.buildFeatures = this.buildFeatures.bind(this);
    this.addPoint = this.addPoint.bind(this);
    this.displayTooltip = this.displayTooltip.bind(this);
    this.getPoint = this.getPoint.bind(this);
    this.removePoints = this.removePoints.bind(this);

    mapboxgl.accessToken = this.map_access_token;
    this.mapBoxMap = null;
  }

  //none -> Control
  //used to build the button on the map to switch between
  //map tiles

  // buildInfoOverlay = () => {
  //   let info = this.state.infoOverlayText;
  //   let divs = []
  //   for( let e in info ) {
  //     if(info[e].visible) {
  //       divs.push(<div className={"info-overlay"}>{info[e].message}</div>);
  //     }
  //   }
  //   return divs;
  // }

  handleZoomClick = (out = false) => {
    let currview = this.map.getView();
    let zoom_increment = out ? -1 : 1;

    currview.setZoom(this.currZoom + zoom_increment);
  };

  buildZoomInOutButtons = () => {
    const IN = false;
    const OUT = true;

    return (
      <div className={"map-btn-group-2"}>
        <div className={"custom-map-control"}>
          <div className={`btn`} onClick={() => this.handleZoomClick(IN)}>
            <i className="fa fa-plus" aria-hidden="true" />
          </div>
        </div>

        <div className={"custom-map-control"}>
          <div className={`btn`} onClick={() => this.handleZoomClick(OUT)}>
            <i className="fa fa-minus" aria-hidden="true" />
          </div>
        </div>
      </div>
    );
  };

  handleSwitchTile = () => {
    if (this.tileType === this.STREET_TILES) {
      this.tileType = this.SAT_TILES;
      this.props.mapTypeCallBack && this.props.mapTypeCallBack("satellite");
    } else if (this.tileType === this.SAT_TILES) {
      this.tileType = this.STREET_TILES;
      this.props.mapTypeCallBack && this.props.mapTypeCallBack("streets");
    }

    this.mapBoxMap.setStyle(
      "https://api.mapbox.com/styles/v1/" +
        this.tileType +
        "?access_token=" +
        this.map_access_token
    );
  };

  buildSwitchTileButton = () => {
    return (
      <div className={"custom-map-control globe"}>
        <div
          className={`btn ${this.tileType === this.SAT_TILES ? "focused" : ""}`}
          onClick={this.handleSwitchTile}
        >
          <i className="fa fa-globe" aria-hidden="true" />
        </div>
      </div>
    );
  };

  // takes an array w/ lat,lng data and fits the map view to it.
  setFocusedFeatures(points) {
    if (points && points.length) {
      let coords = points.map((point) =>
        olProj.fromLonLat([point.lon, point.lat])
      );
      let extent = olExtent.boundingExtent(coords);
      this.map.getView().fit(extent, { padding: FIT_PADDING });
      this.setState({ focusedPoints: points });
    }
  }

  // [List-of Feature] -> [List-of Feature]
  // Used to digest and format a list of features for display on the map
  // This function is exposed to the parent component
  buildFeatures(features, config = {}) {
    if (!features || !features.length) return [];

    let createdOLFeatures = [];
    // CONVEX HULL CASE
    if (config.featureType === "convex_hull") {
      console.log(config, "config");
      if (config.groupBy) {
        //get all values of a group
        let groups = [
          ...new Set(features.map((d) => d[config.groupBy]).filter((d) => !!d)),
        ];

        if (groups.length) {
          groups.forEach((g) => {
            let featureGroup = features.filter((d) => d[config.groupBy] === g);
            let style = config.getGroupedFeatureStyle
              ? config.getGroupedFeatureStyle(featureGroup[0])
              : null;
            let hullFeature = this.buildConvexHullPoly(featureGroup, style, config);
            if (hullFeature) {
              createdOLFeatures.push(hullFeature);
            } else {
              // Fewer than 2 valid points for this group -- there's no polygon
              // to draw. Report it so the parent can tell the user their turf
              // needs more addresses, instead of letting an undefined feature
              // reach VectorSource and crash the map.
              this.props.onLayerError &&
                this.props.onLayerError({
                  reason: "insufficient_points",
                  layerId: config.id,
                  groupBy: config.groupBy,
                  groupValue: g,
                  pointCount: featureGroup.length,
                  turfId: config.turfId,
                  turfName: config.turfName,
                  doorcanvasspassId: config.doorcanvasspassId,
                });
            }
          });
        } else {
          config.groupBy = null;
        }
      }

      //intentionally not an 'else' to catch the case in which group by doesn't return any valid groups
      if (!config.groupBy) {
        let hullFeature = this.buildConvexHullPoly(
          features,
          config.getGroupedFeatureStyle
            ? config.getGroupedFeatureStyle(features[0])
            : null,
          config
        );
        if (hullFeature) {
          createdOLFeatures.push(hullFeature);
        } else {
          this.props.onLayerError &&
            this.props.onLayerError({
              reason: "insufficient_points",
              layerId: config.id,
              pointCount: features.length,
              turfId: config.turfId,
              turfName: config.turfName,
              doorcanvasspassId: config.doorcanvasspassId,
            });
        }
      }
    }
    // LINE STRING CASE
    else if (config.featureType === "line_string") {
      if (config.groupBy === "segments" && features.length > 2) {
        let i = 1;
        while (i < features.length - 1) {
          createdOLFeatures.push(
            this.buildLineString(
              [features[i - 1], features[i]],
              config.getGroupedFeatureStyle
                ? config.getGroupedFeatureStyle(i)
                : null
            )
          );
          i++;
        }
      } else if (config.groupBy) {
        //get all values of a group
        let groups = [
          ...new Set(features.map((d) => d[config.groupBy]).filter((d) => !!d)),
        ];

        if (groups.length) {
          groups.forEach((g, i) => {
            let featureGroup = features.filter((d) => d[config.groupBy] === g);
            let style = config.getGroupedFeatureStyle
              ? config.getGroupedFeatureStyle(i)
              : null;
            createdOLFeatures.push(this.buildLineString(featureGroup, style));
          });
        } else {
          config.groupBy = null;
        }
      }

      //intentionally not an 'else' to catch the case in which group by doesn't return any valid groups
      if (!config.groupBy) {
        const newFeatures = this.buildLineString(
          features,
          config.groupedFeatureStyle
        );

        newFeatures && createdOLFeatures.push(newFeatures);
      }
    } else {
      features.forEach((item, i) => {
        let tempFeature = this.addPoint(item, false);
        if (tempFeature) createdOLFeatures.push(tempFeature);
      });
    }

    console.log("createdOLFeatures", createdOLFeatures);
    // Defensive: never hand OpenLayers an undefined/null "feature" -- it has
    // no null-check of its own and dies deep inside VectorSource with an
    // opaque "reading 'ol_uid' of undefined" error.
    return createdOLFeatures.filter(Boolean);
  }

  //used to removed a passed list of features
  removeFeatures(features, key) {
    let tempFeatures = [];
    features &&
      features.forEach((item, i) => {
        let tempFeature = this.removePoints(item.id);
      });
  }

  // point, boolean -> point
  // helper function to buildFeatures, but also can be used on its own
  // that's why the addToSource toggle is there
  // this function is exposed to the parent component
  addPoint(point, addToSource = true) {
    //filters out null pointer as well as the point [0, 0]

    if (
      point.latitude &&
      point.longitude &&
      [point.longitude, point.latitude] !== [0, 0]
    ) {
      let feature = new Feature({
        geometry: new Point(
          olProj.fromLonLat([
            parseFloat(point.longitude),
            parseFloat(point.latitude),
          ])
        ),
        tooltip: point.tooltip,
        id: point.id,
        name: point.name,
        className: point.className,
        data: point,
      });

      let style =
        point.style ||
        cloneDeep(this.props.defaultPointStyle) ||
        cloneDeep(defaultStyle);
      try {
        feature.setStyle(style);
      } catch (e) {
        console.error("Setting style failed", e, "\n style: ", style);
      }

      if (this.featuresLayer && addToSource) {
        this.featuresLayer.getSource().addFeature(feature);
      }
      return feature;
    } else {
      console.error("NaN lon or lat");
      return false;
    }
  }

  // point -> boolean
  // finds out of a point is within the view of the map, returns true if so
  // this function is exposed to the parent component
  displayTooltip(point) {
    let e = this.map.getView().calculateExtent(this.map.getSize());
    return olExtent.containsCoordinate(
      e,
      olProj.fromLonLat([parseFloat(point.lon), parseFloat(point.lat)])
    );
  }

  // string -> point
  // attempts to find a feature that is on the map with the set id,
  // if it is found, the point is returned
  // this function is exposed to the parent component
  getPoint(id) {
    let focus = this.featuresLayer.getSource().forEachFeature((f) => {
      if (f.get("id") && f.get("id") === id) {
        return f;
      }
    });
    return focus;
  }

  // TODO: REFACTOR
  removePoints(data, type, key) {
    if (!type) type = "id";
    if (!key) key = "featuresLayer";

    if (type === "className") {
      this.featuresLayer.getSource().forEachFeature((f) => {
        if (f.get("className") && f.get("className") === data) {
          this[key].getSource().removeFeature(f);
        }
      });
    } else if (type === "id") {
      this.featuresLayer.getSource().forEachFeature((f) => {
        if (f.get("id") && f.get("id") === data) {
          this[key].getSource().removeFeature(f);
        }
      });
    } else if (type === "coords") {
      this.featuresLayer.getSource().forEachFeature((f) => {
        if (f.getGeometry().flatCoordinates === data) {
          this[key].getSource().removeFeature(f);
        }
      });
    }
  }

  onMoveEnd = (e) => {
    let newZoom = this.map.getView().getZoom();

    if (this.currZoom > newZoom) {
      this.props.zoomOutCallBack && this.props.zoomOutCallBack(newZoom);
    } else if (this.currZoom < newZoom) {
      this.props.zoomInCallBack && this.props.zoomInCallBack(newZoom);
    } else {
      this.props.panCallBack &&
        this.props.panCallBack(this.map.getView().getCenter());
    }

    // You can uncomment this code to re-enable setting text on the points in the zoom styling.

    if (this.props.displayTextZoomLevel) {
      const ZOOM_TEXT_LEVEL = this.props.displayTextZoomLevel;
      if (newZoom > ZOOM_TEXT_LEVEL && this.currZoom <= ZOOM_TEXT_LEVEL) {
        this.setPointLabels();
      } else if (
        newZoom < ZOOM_TEXT_LEVEL &&
        this.currZoom >= ZOOM_TEXT_LEVEL
      ) {
        const REMOVE = true;
        this.setPointLabels(REMOVE);
      }
    }

    //reset the currzoom
    this.currZoom = newZoom;

    this.props.boundsCallBack &&
      this.props.boundsCallBack(
        this.map.getView().calculateExtent(this.map.getSize())
      );
  };

  buildConvexHullPoly = (points, style, config = {}) => {
    if (!points.length) return;

    if (points.length < 2) {
      this.addPoint(points[0]);
      return;
    }

    let targetCoords = points.map((d) =>
      olProj.fromLonLat([+d.longitude, +d.latitude])
    );

    const pointRing = convexHull(targetCoords);
    let polygon = new Polygon([pointRing]); //scale up so it doesn't rest directly on the points
    polygon.scale(1.03);

    let feature = new Feature({
      geometry: polygon,
      data: { id: config.id },
    });

    feature.setStyle(style);
    return feature;
  };

  buildLineString = (
    points,
    style = defaultLineStringStyle({ stroke: "blue" })
  ) => {
    if (!points.length) return;

    if (points.length < 2) {
      this.addPoint(points[0]);
      return;
    }
    let path = points
      .filter((d) => d.longitude && d.latitude)
      .map((d) => [d.longitude, d.latitude]);
    let lineString = new LineString(path).transform("EPSG:4326", "EPSG:3857");
    let feature = new Feature({
      geometry: lineString,
    });

    feature.setStyle(style);
    return feature;
  };

  fitExtentToLayers() {
    let layers = this.map.getLayers().getArray();
    let extent = olExtent.createEmpty();

    let dataExists = false;
    layers.forEach((lyr) => {
      if ((lyr.getProperties() || {}).excludeFromFit) return;

      let source = lyr.getSource();

      // If the source if from a user that has no data, skip it
      // If they have no data, their extent will be infinite
      // this breaks the fit extent
      if (
        source &&
        source.getFeatures().length &&
        !(source.getExtent() || []).includes(NaN) &&
        !(source.getExtent() || []).includes(Infinity)
      ) {
        olExtent.extend(extent, source.getExtent());
        dataExists = true;
      }
    });

    if (dataExists) {
      this.map.getView().fit(extent, {
        padding: FIT_PADDING,
      });
    }
  }

  _addLayer = (layer) => {
    console.log("layer", layer);
    try {
      let olLayer = new VectorLayer({
        source: new VectorSource({
          features: this.buildFeatures(layer.features, { ...layer }),
        }),
      });

      olLayer.setProperties({
        id: layer.id,
        excludeFromFit: layer.excludeFromFit,
      });

      this.map.addLayer(olLayer);
    } catch (e) {
      console.error("Failed to build map layer", layer, e);
      this.props.onLayerError &&
        this.props.onLayerError({
          reason: "layer_build_failed",
          layerId: layer.id,
          error: e,
          turfId: layer.turfId,
          turfName: layer.turfName,
          doorcanvasspassId: layer.doorcanvasspassId,
        });
    }
  };

  _removeLayer = (layer_id) => {
    let layers = this.map.getLayers().getArray();

    layers.forEach((lyr) => {
      let properties = lyr.getProperties();
      if (properties.id === layer_id) {
        this.map.removeLayer(lyr);
      }
    });
  };

  getLayerById = (id) => {
    let layers = this.map.getLayers().getArray();
    let layer;

    layers.forEach((lyr) => {
      let properties = lyr.getProperties();
      if (properties.id === id) {
        layer = lyr;
      }
    });
    return layer;
  };

  //CRUCIAL FUNCTION.
  //THIS WHAT MAKES THE MAPS "REACTIVE", via manual state comparison.
  //we store a hash of each layer on load, check if the hash matches.
  parseLayersUpdate = (prevLayers, currLayers) => {
    let res = {
      enter: [],
      update: [],
      exit: [],
    };

    let prevLayerIds = prevLayers.map((d) => d.id);
    let currLayerIds = currLayers.map((d) => d.id);

    currLayers.forEach((curr) => {
      //check for enter
      if (!prevLayerIds.includes(curr.id)) {
        res.enter.push(curr);
        //handle the update case
      } else {
        if (
          !isEqual(
            curr,
            prevLayers.find((d) => d.id === curr.id)
          )
        ) {
          res.update.push(curr);
        }
      }
    });

    //handle the exit case
    prevLayers.forEach((prev) => {
      if (!currLayerIds.includes(prev.id)) {
        res.exit.push(prev);
      }
    });

    return res;
  };

  /*
   * add a layer with a single point. This is mostly used to "focus" a feature -- i.e. on mouseover
   *  we can add a single point layer to superimposea different style on top.
   *
   * */
  addHoverPointLayer = (feature) => {
    this.removeHoverPointLayer();
    this._addLayer({
      id: "HOVER_POINT_LAYER",
      features: [feature],
    });
  };

  removeHoverPointLayer = () => {
    this._removeLayer("HOVER_POINT_LAYER");
  };

  componentDidMount() {
    //this map box map is being used as a OL layer, so all the controls are set to negative
    this.mapBoxMap = new mapboxgl.Map({
      style:
        "https://api.mapbox.com/styles/v1/" +
        this.tileType +
        "?access_token=" +
        this.map_access_token,
      attributionControl: false,
      boxZoom: false,
      container: this.props.target || "map",
      doubleClickZoom: false,
      dragPan: false,
      dragRotate: false,
      interactive: false,
      keyboard: false,
      pitchWithRotate: false,
      scrollZoom: false,
      touchZoomRotate: false,
    });

    // this is where we turn the map into a layer, all the interaction is coming through the OL api, and being fed to map box
    // this was done so we could use vector layers, ol-mapbox-style was causing a memory leak, so this was the solution
    // this might break when OL/mapbox is updated, so if the map stops working, this could be the cause, make sure to check either the OL
    // upgrade breaks or the mapbox upgrade breaks, by the time that happens, there might be a more streamlined solution worth looking at
    var mapBoxLayer = new Layer({
      zIndex: -999,
      render: (frameState) => {
        let canvas = this.mapBoxMap.getCanvas();
        let viewState = frameState.viewState;

        let visible = mapBoxLayer.getVisible();
        canvas.style.display = visible ? "block" : "none";

        let opacity = mapBoxLayer.getOpacity();
        canvas.style.opacity = opacity;

        this.mapBoxMap.jumpTo({
          center: olProj.toLonLat(viewState.center),
          zoom: viewState.zoom - 1,
          animate: false,
        });

        if (this.mapBoxMap._frame) {
          this.mapBoxMap._frame.cancel();
          this.mapBoxMap._frame = null;
        }
        this.mapBoxMap._render();

        return canvas;
      },
    });

    // create map object with the feature layer
    this.map = new Map({
      controls: [], //disable default
      target: this.props.target || "map",
      interactions: defaultInteractions({
        pinchZoom: false,
        altShiftDragRotate: false,
      }), // so our points layer doesn't get screwed up on mobile
      layers: [
        //default layer
        mapBoxLayer,
        // this.featuresLayer,
      ],
      view: new View({
        center: [-98579516.28, 3982283.17],
        zoom: 3,
      }),
    });

    window.map = this.map;

    this.map.getView().setMaxZoom(18);

    // selectHover used for hover callback
    let selectHover = new Select({ condition: pointerMove, style: null });

    this.map.addInteraction(selectHover);

    selectHover.on("select", (e) => {
      console.log("e.target", e.target.getFeatures().getArray());
      if (e.target.getFeatures().getLength()) {
        this.props.onMarkerHover &&
          this.props.onMarkerHover(
            e.target.getFeatures().getArray()[0].getProperties().data
          );
      } else {
        this.props.onMarkerHover && this.props.onMarkerHover(null);
      }
    });

    if (this.props.onClick) {
      // this.map.addInteraction(selectClick);

      this.map.on("singleclick", (e) => {
        this.props.onClick(e);
      });
    }

    //pan and zoom events
    //initiate the currZoom variable
    this.currZoom = this.map.getView().getZoom();

    this.props.layers.forEach((lyr) => this._addLayer(lyr));

    this.map.on("moveend", this.onMoveEnd);

    this.fitExtentToLayers();
  }

  componentDidUpdate(prevProps, prevState) {
    // if ((prevState.focusedPoints !== this.props.focusedPoints)) {
    //     this.setFocusedFeatures(this.props.focusedPoints)
    // }

    let { enter, update, exit } = this.parseLayersUpdate(
      prevProps.layers,
      this.props.layers
    );

    enter.forEach((layer) => {
      this._addLayer(layer);
    });

    exit.forEach((layer) => {
      this._removeLayer(layer.id);
    });

    update.forEach((layer) => {
      this._removeLayer(layer.id);
      this._addLayer(layer);
    });

    // if (update.length) {
    //     console.log("UPDATE", update)
    // }

    if (enter.length > 1 || exit.length > 1 || update.length > 1) {
      this.fitExtentToLayers();
    }
  }

  render() {
    return (
      <>
        <div
          className={`ol-map ${this.props.containMap ? "contained" : ""} ${
            this.props.className || ""
          }`}
          id={this.props.target || "map"}
        />
        <div className={"map-custom-controls-wrapper"}>
          {this.buildZoomInOutButtons()}
          {this.buildSwitchTileButton()}
        </div>
      </>
    );
  }
}

export default OLLayerMap;
